import { useReducer } from 'react';
import { type ModuleFilteringRule, ModuleSortingField, type ModuleSortingRule, SortingOrder } from '../../../api/types';
import {
    type ExtendedPageAction,
    extendedReducer,
    type ExtendedPageState,
} from '../../../components/PaginatedTableWithContext';
import { TableSortingOrder, type SortOrderValue } from '../../../utilities/useSortAndFilterCache';

type SortRule = ModuleSortingRule & SortOrderValue;
type State = ExtendedPageState & {
    sort: SortRule;
    filter: ModuleFilteringRule;
};

export type SetSortAction = { type: 'setSort'; sortBy: SortRule };

export type SetFilterAction = { type: 'setFilter'; filterBy: ModuleFilteringRule };

export type Action = ExtendedPageAction | SetFilterAction | SetSortAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'setPage':
            return { ...state, page: action.page };

        case 'setPageSize':
            return { ...state, page: 0, pageSize: action.pageSize };

        case 'setSort':
            return { ...state, page: 1, sort: action.sortBy };

        // On set filter, reset the page to 1
        case 'setFilter':
            return { ...state, filter: action.filterBy, page: 1 };

        default:
            return extendedReducer(state, action);
    }
};

const useListReducer = (cache?: State) =>
    useReducer(reducer, {
        companyId: cache?.companyId,
        // default pagination
        page: cache?.page || 1,
        pageSize: cache?.pageSize || 10,

        // default sorting
        sort: cache?.sort || {
            field: ModuleSortingField.DisplayName,
            order: SortingOrder.Asc,
            orderValue: TableSortingOrder.Asc,
        },

        filter: cache?.filter || {},
    });

export default useListReducer;
